import { postApi } from '../api/digitalVault';
export default (repositoryName, sources, destination, configParams, logger) => {
    const data = new URLSearchParams();
    data.append('destination', destination);
    sources.forEach((s) => data.append('source', s.toString()));
    if (configParams) {
        data.append('safe', String(configParams.safe));
        data.append('conflictSolve', configParams.conflictSolve);
    }
    return postApi(data, `repository/${repositoryName}/operations/move`, {}, logger);
};
